
const Experience = () => {

    const logosData = [
        {
            src: "images/brand-1.jpg",
            href: "https://shop.hasbro.com/",
        },
        {
            src: "images/brand-2.jpg",
            href: "https://hyperx.com/",
        },
        {
            src: "images/brand-3.jpg",
            href: "https://www.ufcstore.com/",
        },
        {
            src: "images/brand-4.jpg",
            href: "https://dockers.com/",
        },
        {
            src: "images/brand-5.jpg",
            href: "https://www.goodamerican.com/",
        },
        {
            src: "images/brand-6.jpg",
            href: "https://www.dormify.com/",
        },
    ]

    return (
        <div className="mb-24">
            {/* PAGES I'VE WORKED ON section */}
            <div className="flex justify-center mb-5">
                <div className="max-w-[1280px] w-full mb-8 lg:mb-0">
                    <div className="my-12 text-center text-2xl text-animate">
                        <h1 className="mb-6 px-5 lg:text-4xl">The #1 Shopify Plus Web Development Agency</h1>
                        <p className="text-lg px-6 text-left lg:text-center">At <i>We Make Websites,</i> the top shopify web development agency, I worked as a frontend developer contributing to projects for global brands. I helped implement responsive UI components, polished animations, and Liquid-based customizations — all with a focus on scalability, performance, and clean code.</p>
                    </div>
                </div>
            </div>
            <div className="flex justify-center bg-white">
                <div className="w-full max-w-[1280px] flex justify-evenly py-5 flex-wrap gap-x-4 lg:gap-x-0 text-animate">
                    {
                        logosData.map((logo, index) => (
                            <a
                                key={index}
                                className="flex w-[100px] lg:w-auto"
                                href={logo.href}
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img
                                    className="self-center"
                                    src={logo.src}
                                    alt=""
                                />
                            </a>
                        ))
                    }
                    
                </div>
            </div>
        </div>
    );
};

export default Experience;